import { createAction, props } from '@ngrx/store';
import { LookupValue } from 'src/app/models/lookup.model';
import { ORingProductFamily, ORingSBU, ORing, ORingSellable, ORingSubSBU, ORingProductSizeValue, ORingMaterialName, ORingProductFamilyName, ORingSBUName, ORingSubSBUName, ORingSellableId, ORingProductTypeName } from 'src/app/models/oring.model';
import { ORingFilter } from '../fromORing.barrel';

const prefix = '[ORing]';

// the load to return the results of the query with the filter inputs
export const loadORings = createAction(`${prefix} load ORings`);
export const loadORingsSuccess = createAction(`${prefix} Load ORing Success`, props<{ data: ORing[] }>());
export const loadORingsFail = createAction(`${prefix} Load ORing Failure`, props<{ error: any }>());

// a way to trigger a load for all the lookup values at once
export const loadORingsLookups = createAction(`${prefix} load lookups`);

// this is the update to the filter which will trigger loadORings
export const updateORingFilter = createAction(`${prefix} update oring filter`, props<{ obj: Partial<ORingFilter> }>());

// this will toggle the sellable code selection on the filter
export const toggleSellableCode = createAction(`${prefix} toggle sellable code`, props<{ code: string | null }>());

// this will select the indicated sealing element
export const toggleSelectedProduct = createAction(`${prefix} toggle selected product`, props<{ partNumber: string }>());
export const clearSelectedProduct = createAction(`${prefix} clear selected product`);
export const loadSelectedProductSuccess = createAction(`${prefix} load selected product success`);
export const toggleNextSelectedProduct = createAction(`${prefix} toggle next selected product`);
export const togglePreviousSelectedProduct = createAction(`${prefix} toggle previous selected product`);

// lookups
export const loadPipeSizes = createAction(`${prefix} load pipe sizes`);
export const loadPipeSizesSuccess = createAction(`${prefix} load pipe sizes success`, props<{ data: ORingProductSizeValue[] }>());
export const loadPipeSizesFail = createAction(`${prefix} load pipe sizes fail`, props<{ error: any }>());

// lookups
export const loadMaterials = createAction(`${prefix} load materials`);
export const loadMaterialsSuccess = createAction(`${prefix} load materials success`, props<{ materials: ORingMaterialName[] }>());
export const loadMaterialsFail = createAction(`${prefix} load materials fail`, props<{ error: any }>());

// lookups
export const loadProductFamilies = createAction(`${prefix} load families`);
export const loadProductFamiliesSuccess = createAction(`${prefix} load families success`, props<{ families: ORingProductFamilyName[] }>());
export const loadProductFamiliesFail = createAction(`${prefix} load families fail`, props<{ error: any }>());

// lookups
export const loadSBUs = createAction(`${prefix} load SBUs`);
export const loadSBUsSuccess = createAction(`${prefix} load SBUs success`, props<{ sbus: ORingSBU[] }>());
export const loadSBUsFail = createAction(`${prefix} load SBUs fail`, props<{ error: any }>());

// lookups
export const loadSubSBUs = createAction(`${prefix} load SubSBUs`);
export const loadSubSBUsSuccess = createAction(`${prefix} load SUbSBUs success`, props<{ subSBUs: ORingSubSBU[] }>());
export const loadSubSBUsFail = createAction(`${prefix} load SubSBUs fail`, props<{ error: any }>());

//lookups
export const loadSellables = createAction(`${prefix} load sellables`);
export const loadSellablesSuccess = createAction(`${prefix} load sellables success`, props<{ sellables: ORingSellableId[] }>());
export const loadSellablesFail = createAction(`${prefix} load sellables fail`, props<{ error: any }>());

// lookups
export const loadProductTypes = createAction(`${prefix} load productTypes`);
export const loadProductTypesSuccess = createAction(`${prefix} load productTypes success`, props<{ productTypes: ORingProductTypeName[] }>());
export const loadProductTypesFail = createAction(`${prefix} load productTypes fail`, props<{ error: any }>());
